import React, { FunctionComponent } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import KeyboardTabIcon from '@mui/icons-material/KeyboardTab';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { sendSelectedItemsToBack } from '../../actions/annotations';

type Props = ReturnType<typeof mapDispatchToProps>;

const SendToBack: FunctionComponent<Props> = ({ sendSelectedItemsToBack }) => (
  <Tooltip disableInteractive disableFocusListener id="remove-page-tooltip" title="Send To Back">
    <div>
      <IconButton sx={{ borderRadius: 0 }} aria-label="Send to Back" onClick={sendSelectedItemsToBack}>
        <KeyboardTabIcon sx={{ transform: 'rotate(90deg)' }} />
      </IconButton>
    </div>
  </Tooltip>
);

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators({ sendSelectedItemsToBack }, dispatch);
}

export default connect(null, mapDispatchToProps)(SendToBack);
